import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { useUserData } from "../../hooks/UserContext";
import { changeQuantityItemCart } from "../../Redux/cartSlice";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import { Quantity } from "./style";
import notify from "components/UI/toast";
import { trackClick } from "../../utils/gtm";
import { tagIdFromLegacySuffix } from "../../utils/marketplaceTagIds";
import { useScreenTracking } from "../../hooks/useScreenTracking";

export default function InputCardQuantity({ uuid, sku, amount, value, maxQty, onQuantityError, onQuantityValid }) {
  const [quantity, setQuantity] = useState(amount);
  const screenName = useScreenTracking();

  useEffect(() => {
    setQuantity(amount);
  }, [amount]);

  const { user, addressShipping } = useUserData();

  const customerUuid = user.uuid;
  const cep = addressShipping.cep;

  const dispatch = useDispatch();

  const sendQuantityAnalytics = (action) => {
    const titleMap = {
      'add': 'aumentar-quantidade',
      'remove': 'diminuir-quantidade'
    };

    trackClick({
      title: titleMap[action],
      contentType: "carrinho",
      screenName,
      tagId: tagIdFromLegacySuffix("15"),
    });
  };

  const changeApi = (sku, qtd, action) => {
    const jsonCart = {};
    (jsonCart.sku = sku),
    (jsonCart.quantity = qtd),
    (jsonCart.cep = cep),
    (jsonCart.customerUuid = customerUuid);
    const uuid = customerUuid
    dispatch(changeQuantityItemCart({ jsonCart, uuid, cep, action }));
  };

  const addCart = () => {
    let result = quantity + 1;
    if (result <= maxQty) {
      setQuantity(result);
      changeApi(sku, result, 'add');
      sendQuantityAnalytics('add');
      
      if (onQuantityValid) onQuantityValid(uuid);
      return result;
    } else {
      notify(
        "A quantidade informada não está disponível para este produto.",
        "error"
      );
      if (onQuantityError) onQuantityError(uuid);
    }
  };

  const decrementCart = (newQtd) => {
    let result = quantity - 1;
    if (result > 0) {
      setQuantity(result);
      changeApi(sku, result, 'remove');
      sendQuantityAnalytics('remove');
      
      if (result <= maxQty && onQuantityValid) onQuantityValid(uuid);
      return result;
    }
  };

  return (
    <div className="d-flex justify-content-between">
      <Quantity className="d-flex align-items-center">
        <button
          type="button"
          className="btn rounded-0"
          onClick={() => decrementCart()}
        >
          {" "}
          <AiOutlineMinus size={10} />
        </button>
        <span className="text-sm">{quantity}</span>
        <button
          type="button"
          className="btn rounded-0"
          onClick={() => addCart()}
        >
          {" "}
          <AiOutlinePlus size={10} />
        </button>
      </Quantity>
      <div className="d-flex align-items-center">
        <span className="font-wl-500 text-xs color-wl color-opacty-60">
          {value}
        </span>
      </div>
    </div>
  );
}

InputCardQuantity.propTypes = {
  amount: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  sku: PropTypes.string.isRequired,
  maxQty: PropTypes.number.isRequired, // Change type = string to number
  onQuantityError: PropTypes.func,
  onQuantityValid: PropTypes.func,
};
